<template>
  <div class="private">
    <div>
      <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
        <span
          style="width: 21pt; text-indent: 0pt; display: inline-block;"
        ></span
        ><span
          style="width: 21pt; text-indent: 0pt; display: inline-block;"
        ></span
        ><span
          style="width: 21pt; text-indent: 0pt; display: inline-block;"
        ></span
        ><span
          style="width: 21pt; text-indent: 0pt; display: inline-block;"
        ></span
        ><span
          style="width: 21pt; text-indent: 0pt; display: inline-block;"
        ></span
        ><span style="font-family: Calibri; font-size: 10.5pt;"> </span
        ><span style="font-family: Calibri; font-size: 10.5pt;"> </span
        ><span style="font-family: 宋体; font-size: 10.5pt;">免责条款</span>
      </p>
      <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
        <span
          style="width: 21pt; text-indent: 0pt; display: inline-block;"
        ></span
        ><span style="font-family: 宋体; font-size: 10.5pt;"
          >本着对投资者负责的态度，五矿</span
        ><span style="font-family: 宋体; font-size: 10.5pt;"
          >证券在此向您郑重提醒，请务必仔细阅读并透彻理解本声明。如您继续使用，您的使用行为将被视为对本声明内容已完全了解并同意承担可能存在的全部风险：</span
        >
      </p>
      <p
        style="
          margin: 0pt;
          orphans: 0;
          text-align: justify;
          text-indent: 20pt;
          widows: 0;
        "
      >
        <span style="font-family: Calibri; font-size: 10.5pt;">1</span
        ><span style="font-family: 宋体; font-size: 10.5pt;"
          >、由于无线通信网、互联网存在被恶意攻击、感染病毒的可能性，无线通信网、互联网服务器可能会出现故障及其他不可预测的状况。此种情况下，交易指令可能会出现中断、停顿、延迟、数据错误等情况，行情信息和其他证券信息可能会出现错误或延迟，我司对此及由此导致的任何损失均不承担法律责任。若出现上述情况，建议投资者采用其他委托方式（电话委托或网上交易）进行行情查询及交易。</span
        >
      </p>
      <p
        style="
          margin: 0pt;
          orphans: 0;
          text-align: justify;
          text-indent: 20pt;
          widows: 0;
        "
      >
        <span style="font-family: Calibri; font-size: 10.5pt;">2</span
        ><span style="font-family: 宋体; font-size: 10.5pt;"
          >、本软件中的部分资讯信息是由第三方提供，我司不保证信息、数据资料的准确性、真实性、完整性等。该内容亦不构成任何可以带来收益的投资建议。投资者依据本软件提供的信息进行金融、证券等投资操作所导致的盈亏由投资者自行承担，与我司无关。</span
        >
      </p>
      <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
        <span
          style="width: 21pt; text-indent: 0pt; display: inline-block;"
        ></span
        ><span style="font-family: Calibri; font-size: 10.5pt;">3</span
        ><span style="font-family: 宋体; font-size: 10.5pt;"
          >、您的移动终端故障、配置和性能与本软件不相匹配、操作不当或不熟练等因素，均可能造成本软件的无法使用、委托失败或错误，对此造成的损失我司不承担法律责任。</span
        >
      </p>
      <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
        <span
          style="width: 21pt; text-indent: 0pt; display: inline-block;"
        ></span
        ><span style="font-family: Calibri; font-size: 10.5pt;">4</span
        ><span style="font-family: 宋体; font-size: 10.5pt;"
          >、投资者应避免在非安全环境下进行使用本软件。在使用本软件过程中，请妥善保管好自己所使用的移动设备、个人信息及密码，以防被他人盗用。凡通过密码验证情况下进行的交易及相关行为，均视为您自身进行的交易及相关行为，由此产生的一切后果及责任将由您自行承担。</span
        >
      </p>
      <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
        <span
          style="width: 21pt; text-indent: 0pt; display: inline-block;"
        ></span
        ><span style="font-family: Calibri; font-size: 10.5pt;">5</span
        ><span style="font-family: 宋体; font-size: 10.5pt;"
          >、证券监督机构认定的其他风险。</span
        >
      </p>
      <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
        <span
          style="width: 21pt; text-indent: 0pt; display: inline-block;"
        ></span
        ><span style="font-family: Calibri; font-size: 10.5pt;">6</span
        ><span style="font-family: 宋体; font-size: 10.5pt;"
          >、本软件无任何软件使用费，但由于使用上网数据而产生的流量费由运营商收取，具体资费参见相关运营商资费标准。</span
        >
      </p>
      <p style="margin: 0pt; orphans: 0; text-align: justify; widows: 0;">
        <span
          style="width: 21pt; text-indent: 0pt; display: inline-block;"
        ></span
        ><span style="font-family: Calibri; font-size: 10.5pt;">7</span
        ><span style="font-family: 宋体; font-size: 10.5pt;"
          >、本声明的最终解释权归五矿证券所有。</span
        >
      </p>
    </div>
  </div>
</template>
<style>
body {
  height: 100%;
  padding: 0;
  margin: 0;
}
</style>
<script>
import "../../service/td-h5-hybird-sdk";
export default {
  name: "klineindex",
  components: {},
  directives: {},
  data() {
    return {};
  },
  // {data:[]}
  computed: {},
  activated() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang="less">
@import "./style/private.less";
</style>
<style></style>
